import { forwardRef, useId } from 'react';

const ChevronIcon = () => (
  <svg
    aria-hidden="true"
    viewBox="0 0 20 20"
    fill="none"
    className="h-4 w-4 text-white/45 transition-transform duration-200 group-focus-within:rotate-180"
  >
    <path
      d="M5 7.5L10 12.5L15 7.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const GlassSelect = forwardRef(function GlassSelect(
  {
    id,
    label,
    options = [],
    value,
    onChange,
    placeholder = 'Seleccionar…',
    isLoading = false,
    isInvalid = false,
    disabled = false,
    emptyMessage = 'Sin opciones disponibles',
    className = '',
    ...rest
  },
  ref,
) {
  const generatedId = useId();
  const selectId = id ?? generatedId;
  const isEmpty = !isLoading && options.length === 0;
  const placeholderText = isLoading
    ? 'Cargando…'
    : isEmpty
    ? emptyMessage
    : placeholder;

  return (
    <div className={`group relative ${className}`}>
      <select
        key={selectId}
        ref={ref}
        id={selectId}
        value={value ?? ''}
        onChange={onChange}
        disabled={disabled || isLoading}
        aria-invalid={isInvalid || undefined}
        aria-label={label}
        className={`glass-input w-full appearance-none rounded-2xl pl-4 pr-10 py-3 text-base text-white/95 ${isInvalid ? 'is-invalid' : ''} ${isLoading || isEmpty ? 'text-white/45' : ''}`}
        {...rest}
      >
        <option value="" disabled className="bg-ink-900 text-white/55">
          {placeholderText}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value} className="bg-ink-900 text-white">
            {option.label}
          </option>
        ))}
      </select>
      <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center">
        <ChevronIcon />
      </span>
    </div>
  );
});

export default GlassSelect;